import { useTheme } from '@emotion/react';

const MainNavigationStyle = () => {
  const theme = useTheme();

  return {
    header_container: {
      height: "64px",
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
      display: "flex",
      alignItems: "center",
    },
    header: {
      width: "100%",
      paddingLeft: "48px",
      paddingRight: "48px",
      display: { xs: "none", md: "flex" },
      justifyContent: "space-between",
      alignItems: "center",
    },
    userInfo: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    avatar: {
      width: 40,
      height: 40,
      fontWeight: 600,
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
    },
    title: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    userRole: {
      fontSize: '13px',
      fontWeight: 500,
      color: theme.palette.text.secondary,
      marginTop: "-2px",
      textTransform: "capitalize",
    },
    res_nav_container: {
      display: { xs: "flex", md: "none" },
      flexDirection: "row",
      alignItems: "center",
      gap: "24px",
      height: "100%",
      marginLeft: '24px',
    },
    logo: {
      height: "48px",
      width: '107px',
      marginLeft: "5px"
    },
  };
};

export default MainNavigationStyle;
